module.exports = __webpack_public_path__ + "media/vvv-dashboard-guide-nl.1a7562d6.mp4";